import React from 'react';

import Icon from '../Icon/Icon';

const CalendarIcon = ({className, ...rest}) => {
    return (
        <Icon width='64' height='64' fill='none' className={className} {...rest}>
            <path
                d='M15.8965 13.8005C15.8965 16.7271 18.2688 19.0992 21.1953 19.0994C24.122 19.0994 26.4951 16.7272 26.4951 13.8005V13.115H37.4902V13.8005C37.4902 16.7271 39.8626 19.0992 42.7891 19.0994C45.7157 19.0994 48.0889 16.7272 48.0889 13.8005V13.115H52C54.2091 13.115 56 14.9059 56 17.115V51.9724C55.9998 54.1814 54.209 55.9724 52 55.9724H12C9.79096 55.9724 8.00015 54.1814 8 51.9724V17.115C8 14.9059 9.79086 13.115 12 13.115H15.8965V13.8005ZM23.9951 13.8005L23.9805 14.0867C23.8372 15.4982 22.6447 16.5994 21.1953 16.5994C19.6495 16.5992 18.3965 15.3464 18.3965 13.8005V13.115H23.9951V13.8005ZM45.5889 13.8005L45.5742 14.0867C45.4309 15.4982 44.2384 16.5994 42.7891 16.5994C41.2433 16.5992 39.9902 15.3464 39.9902 13.8005V13.115H45.5889V13.8005Z'
                fill='#393E44'
            />
            <path
                d='M39.9907 9.79917C39.9907 8.25323 41.244 7 42.7899 7V7C44.3358 7 45.5891 8.25323 45.5891 9.79917V13.798C45.5891 15.3439 44.3358 16.5971 42.7899 16.5971V16.5971C41.244 16.5971 39.9907 15.3439 39.9907 13.798V9.79917Z'
                fill='#00D1D2'
            />
            <path
                d='M18.397 9.79917C18.397 8.25323 19.6502 7 21.1961 7V7C22.7421 7 23.9953 8.25323 23.9953 9.79917V13.798C23.9953 15.3439 22.7421 16.5971 21.1961 16.5971V16.5971C19.6502 16.5971 18.397 15.3439 18.397 13.798V9.79917Z'
                fill='#00D1D2'
            />
            <path
                d='M16 34.5C16 33.9477 16.4477 33.5 17 33.5H21C21.5523 33.5 22 33.9477 22 34.5V38.5C22 39.0523 21.5523 39.5 21 39.5H17C16.4477 39.5 16 39.0523 16 38.5V34.5Z'
                fill='#FFFDFB'
            />
            <path
                d='M29 34.5C29 33.9477 29.4477 33.5 30 33.5H34C34.5523 33.5 35 33.9477 35 34.5V38.5C35 39.0523 34.5523 39.5 34 39.5H30C29.4477 39.5 29 39.0523 29 38.5V34.5Z'
                fill='#FFFDFB'
            />
            <path
                d='M42 34.5C42 33.9477 42.4477 33.5 43 33.5H47C47.5523 33.5 48 33.9477 48 34.5V38.5C48 39.0523 47.5523 39.5 47 39.5H43C42.4477 39.5 42 39.0523 42 38.5V34.5Z'
                fill='#FFFDFB'
            />
            <path
                d='M16 44.5C16 43.9477 16.4477 43.5 17 43.5H21C21.5523 43.5 22 43.9477 22 44.5V48.5C22 49.0523 21.5523 49.5 21 49.5H17C16.4477 49.5 16 49.0523 16 48.5V44.5Z'
                fill='#FFFDFB'
            />
            <path
                d='M29 44.5C29 43.9477 29.4477 43.5 30 43.5H34C34.5523 43.5 35 43.9477 35 44.5V48.5C35 49.0523 34.5523 49.5 34 49.5H30C29.4477 49.5 29 49.0523 29 48.5V44.5Z'
                fill='#FFFDFB'
            />
            <path
                d='M42 44.5C42 43.9477 42.4477 43.5 43 43.5H47C47.5523 43.5 48 43.9477 48 44.5V48.5C48 49.0523 47.5523 49.5 47 49.5H43C42.4477 49.5 42 49.0523 42 48.5V44.5Z'
                fill='#FFFDFB'
            />
            <path d='M8 26L56 26' stroke='#FFFDFB' strokeWidth='2.5' />
        </Icon>
    );
};

export default CalendarIcon;
